/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v10.1.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MethodNotImplementedException = (function () {
    function MethodNotImplementedException() {
    }
    return MethodNotImplementedException;
}());
exports.MethodNotImplementedException = MethodNotImplementedException;



//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/dist/lib/misc/methodNotImplementedException.js
// module id = 177
// module chunks = 1